/**
 * ルートごとの title / description の単一ソース。
 *
 * - src/router/index.js（実行時のメタ更新）
 * - scripts/generate-seo-pages.js（静的HTML生成・sitemap）
 *
 * の両方がここを参照する。nodeスクリプトからも require できるよう
 * CommonJS 形式で書くこと（webpackはCJSのままimportできる）。
 *
 * title: null はトップページ（サイト名のみをタイトルにする）。
 */
const SITE_URL = "https://exships.jp";
const BASE_TITLE = "合同会社エクスシップス";
const DEFAULT_DESCRIPTION =
  "テクノロジーと人の力で価値を創出するITソリューション企業。スマートフォン向けアプリ開発・DevOps推進・Webサイト制作を提供します。";

const staticRoutes = [
  {
    path: "/",
    title: null,
    description: DEFAULT_DESCRIPTION,
  },
  {
    path: "/message",
    title: "会社メッセージ",
    description:
      "合同会社エクスシップス代表・小塚啓太からのメッセージ。テクノロジーと誠実さで、お客様と共に成長してまいります。",
  },
  {
    path: "/company",
    title: "会社概要",
    description:
      "合同会社エクスシップス（exships LLC）の会社概要。設立2020年、東京都大田区。アプリ開発・DevOps・Web制作を手がけるITソリューション企業です。",
  },
  {
    path: "/projects",
    title: "会社事業",
    description:
      "エクスシップスの事業内容。スマートフォン向けアプリ開発（iOS/Android）、DevOps・アジャイル開発推進、Webサイト制作の3つの柱でITソリューションを提供します。",
  },
  {
    path: "/blog",
    title: "公式ブログ",
    description:
      "合同会社エクスシップス（エクスシップス）の公式ブログ。AI・モバイル開発・DevOps・Web制作など、技術とチームの取り組みを発信しています。",
  },
  {
    path: "/contact",
    title: "お問い合わせ",
    description:
      "合同会社エクスシップスへのお問い合わせ。アプリ開発・DevOps・Webサイト制作のご相談はこちらからお気軽にどうぞ。",
  },
  {
    path: "/privacy_policy",
    title: "プライバシーポリシー",
    description: "合同会社エクスシップスのプライバシーポリシーです。",
  },
  {
    path: "/terms_of_use",
    title: "利用規約",
    description: "合同会社エクスシップスの利用規約です。",
  },
];

module.exports = { SITE_URL, BASE_TITLE, DEFAULT_DESCRIPTION, staticRoutes };
